import { useEffect, useState } from 'react';

import { dayOptions } from '@components/payment-collection/constants';
import { DayOptionsType } from '@types';

interface DayPickerProps {
  onChange: (selectedDays: DayOptionsType[]) => void;
  markedDays?: DayOptionsType[];
  dayOptionClassName?: string;
}

const DayPicker: React.FC<DayPickerProps> = ({
  onChange,
  markedDays,
  dayOptionClassName
}) => {
  const [selectedDays, setSelectedDays] = useState<DayOptionsType[]>([]);

  const handleDayClick = (item: DayOptionsType) => {
    const prevSelectedDays = [...selectedDays];
    const newSelectedDays = prevSelectedDays.some((day) => day.id === item.id)
      ? prevSelectedDays.filter((day) => day.id !== item.id)
      : [...prevSelectedDays, item];
    setSelectedDays(newSelectedDays);
    onChange(newSelectedDays);
  };

  useEffect(() => {
    setSelectedDays(markedDays || []);
  }, [markedDays]);

  return (
    <div>
      <div className="flex gap-2 pb-4">
        {dayOptions.map((item) => (
          <div
            key={item.id}
            className={`flex size-12.5 cursor-pointer items-center justify-center rounded-lg border text-sm font-semibold ${
              selectedDays.some((day) => day.id === item.id)
                ? 'border-cofeePrimary6 bg-cofeePrimary1 text-cofeeNeutral10'
                : `border-cofeeGreyBlue5 bg-cofeeGreyBlue1 text-cofeeNeutral10 ${dayOptionClassName}`
            }`}
            role="presentation"
            onClick={() => handleDayClick(item)}
          >
            {item.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DayPicker;
